import { useContrastQuery } from '../../hooks/use-contrast-query'
import {
  getData,
  GetLibraryDataProps
} from '../../sca/libraries/api/react-query'
import { VulnerabilityReport } from './cve-interfaces'

export function useCveFilter(organizationUuid: string, cveId: string) {
  return useContrastQuery<GetLibraryDataProps, VulnerabilityReport>(
    ['cve-filter', organizationUuid, cveId],
    getData,
    {
      url: `/Contrast/api/ng/organizations/${organizationUuid}/cves/${cveId}`,
      method: 'GET'
    }
  )
}
